/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SelectPlanPreconditionPayload = {
    selection: SelectPlanPreconditionPayload.selection;
    type: SelectPlanPreconditionPayload.type;
};
export namespace SelectPlanPreconditionPayload {
    export enum selection {
        FREE = 'free',
        PAID = 'paid',
        MULTI_USER = 'multiUser',
    }
    export enum type {
        SELECT_PLAN = 'select-plan',
        CONFIGURATION = 'configuration',
        BILLING = 'billing',
        OPENINGS = 'openings',
        WAITLIST = 'waitlist',
        ONBOARDING_GENERAL = 'onboarding-general',
        ONBOARDING_FIRST_CATEGORY = 'onboarding-first-category',
        ONBOARDING_AVAILABILITY = 'onboarding-availability',
        ONBOARDING_DISTRIBUTION = 'onboarding-distribution',
        ONBOARDING_FINISHED = 'onboarding-finished',
        ONBOARDING_PROFILE = 'onboarding-profile',
        ONBOARDING_FIRST_EVENTS = 'onboarding-first-events',
        ONBOARDING_BOOKING_SITES = 'onboarding-booking-sites',
        ONBOARDING_WIDGET = 'onboarding-widget',
    }
}

